module.exports = __webpack_public_path__ + "media/assets/images/nexa@3x-a61fe1918daf94e2287f3f9d79280a20.png";